const colors = {
  warn: "#ffb347",
  pageBackground: "#f3f4f6",
  grey: "#778094",
  darkBlue: "#2f4b79",
  hexToRgb: (hex: any) => {
    return hex
      .replace(
        /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        (_: any, r: string, g: string, b: string) => "#" + r + r + g + g + b + b
      )
      .substring(1)
      .match(/.{2}/g)
      .map((x: string) => parseInt(x, 16));
  },
  hexToRgba: (h: string, a: number): string => {
    let r = "0",
      g = "0",
      b = "0";

    // 3 digits
    if (h.length === 4) {
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];

      // 6 digits
    } else if (h.length === 7) {
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }
    return "rgba(" + +r + "," + +g + "," + +b + ", " + a + ")";
  },
  colorScale: (
    startColorHex: string,
    endColorHex: string,
    numColors: number
  ): string[] => {
    const startRed = parseInt(startColorHex.slice(1, 3), 16);
    const startGreen = parseInt(startColorHex.slice(3, 5), 16);
    const startBlue = parseInt(startColorHex.slice(5, 7), 16);
    const endRed = parseInt(endColorHex.slice(1, 3), 16);
    const endGreen = parseInt(endColorHex.slice(3, 5), 16);
    const endBlue = parseInt(endColorHex.slice(5, 7), 16);
    const redDiff =
      Math.abs(startRed - endRed) / (numColors === 1 ? 1 : numColors - 1);
    const greenDiff =
      Math.abs(startGreen - endGreen) / (numColors === 1 ? 1 : numColors - 1);
    const blueDiff =
      Math.abs(startBlue - endBlue) / (numColors === 1 ? 1 : numColors - 1);
    return [...Array(numColors)].map((_, index) => {
      const red =
        startRed > endRed
          ? startRed - index * redDiff
          : startRed + index * redDiff;
      const green =
        startGreen > endGreen
          ? startGreen - index * greenDiff
          : startGreen + index * greenDiff;
      const blue =
        startBlue > endBlue
          ? startBlue - index * blueDiff
          : startBlue + index * blueDiff;
      const hexRed =
        Math.round(red).toString(16).length < 2
          ? `0${Math.round(red).toString(16)}`
          : Math.round(red).toString(16);
      const hexGreen =
        Math.round(green).toString(16).length < 2
          ? `0${Math.round(green).toString(16)}`
          : Math.round(green).toString(16);
      const hexBlue =
        Math.round(blue).toString(16).length < 2
          ? `0${Math.round(blue).toString(16)}`
          : Math.round(blue).toString(16);
      return `#${hexRed}${hexGreen}${hexBlue}`;
    });
  },
  createGradient: (start: string, end: string): string =>
    `linear-gradient(135deg, ${start} 0%, ${end} 100%)`,
  distinct: [
    "#82CFE8",
    "#CEA9D9",
    "#91BD7B",
    "#F7A612",
    "#FCE6BB",
    "#757CF6",
    "#fd98aa",
    "#ff8585",
  ],
  sequential: [
    "#3A6795",
    "#A1DAEC",
    "#347C84",
    "#A1DED9",
    "#5DAB91",
    "#B9ECCA",
  ],
};

export default colors;
